// 企业预约相关接口，公对公
let dev = process.env.dev;
dev = dev + "/c";

export default {
  //【企业主】企业主信息提交
  companyOrderSave: {
    url: dev + "/sv/company/order/save",
    method: "post",
    config: {
      closeLoading: true,
      noRedirect: true,
    },
  },

  //【企业主】企业单据详情
  companyOrderdetail: { url: dev + "/sv/company/order/detail", method: "get" },

  //【企业主】企业单据详情
  companySimpleinfo: { url: dev + "/sv/company/simpleinfo", method: "get" },

  //【企业主】根据unionId获取企业单信息，服务端根据token获取unionId
  companyGetcompanyorderUnionid: {
    url: dev + "/sv/company/getcompanyorder/unionid",
    method: "get",
    config: {
      closeLoading: true,
      noRedirect: true,
    },
  },

  //【企业主】生成合同
  companyElectronicContractSave: {
    url: dev + "/sv/company/electronic/contract/save",
    method: "post",
  },

  //【企业主】查看合同
  companyElectronicContract: {
    url: dev + "/sv/company/electronic/contract",
    method: "get",
  },

  //【企业主】提交预约
  companyOrderSubmit: { url: dev + "/sv/company/order/submit", method: "post" },

  //【预约人】新增、编辑
  companyAppointmentsSave: {
    url: dev + "/sv/company/appointments/save",
    method: "post",
  },

  //【预约人】删除
  companyAppointmentsDelete: {
    url: dev + "/sv/company/appointments/delete",
    method: "post",
  },

  //【预约人】根据企业单号、查询当前登录人的预约人信息
  companyGetAppointments: {
    url: dev + "/sv/company/getappointments",
    method: "get",
    config: {
      closeLoading: true,
      noRedirect: true,
    },
  },

  //【绑定人】根据企业单号、查询当前登录人的绑定信息
  companyBindGetappointment: {
    url: dev + "/sv/company/bind/getappointment",
    method: "get",
    config: {
      closeLoading: true,
      noRedirect: true,
    },
  },

  //【企业主】支付信息页面查询
  companyOrderPayDetail: {
    url: dev + "/sv/company/order/pay/detail",
    method: "get",
  },

  //【C】C端用户绑定
  companyAppointmentsBind: {
    url: dev + "/sv/company/appointments/bind",
    method: "post",
  },
};



// WEBPACK FOOTER //
// ./src/api/company.js